import { ssapModalTypes } from './ssapModalTypes';

export const ssapModalConfig = [
    {
        modalType: ssapModalTypes.ADD_EMPLOYER_COVERAGE_DETAIL_MODAL,
        modalId: 'add-employer-coverage-detail-modal',
        modalHeaderTextData: 'modals.header.employer_coverage_details',
        formName: 'employerCoverageDetailModalForm',
        bodyId: 'employerCoverageDetailsModal',
    },
    {
        modalType: ssapModalTypes.ADD_INCOME_OR_DEDUCTION_SOURCE_MODAL,
        modalId: 'add-income-or-deduction-source-modal',
        modalHeaderTextData: isIncomeSource =>
            isIncomeSource
                ? 'modals.header.add_income_deduction.income'
                : 'modals.header.add_income_deduction.deduction',
        formName: 'incomeDeductionSourceModalForm',
        bodyId: 'addIncomeOrDeductionModal',
    },
    {
        modalType: ssapModalTypes.ADD_HRA_DETAIL_MODAL,
        modalId: 'add-employer-coverage-detail-modal',
        modalHeaderTextData: 'modals.header.employer_coverage_details',
        formName: 'employerHraDetailModalForm',
        bodyId: 'hraDetailsModal',
    },
    {
        modalType: ssapModalTypes.DECEASED_MEMBER_MODAL,
        modalId: 'deceased-member-modal',
        modalHeaderTextData: 'modals.header.deceased_member_confirmation',
        formName: 'deceasedMemberModalForm',
        bodyId: 'deceasedMemberModal',
    },
    {
        modalType: ssapModalTypes.EXPECTED_INCOME_MODAL,
        modalId: 'expected-income-modal',
        modalHeaderTextData: 'modals.header.expected_income',
        bodyId: 'expectedIncomeModal',
    },
    {
        modalType: ssapModalTypes.INDEPENDENT_TAX_FILERS_MODAL,
        modalId: 'independent-tax-filers-modal',
        modalHeaderTextData: 'modals.header.household_info',
        bodyId: 'independentTaxFilersModal',
    },
    {
        modalType: ssapModalTypes.INFORM_TO_ADD_INCOME_SOURCE_MODAL,
        modalId: 'inform-to-add-income-source-modal',
        modalHeaderTextData: 'modals.header.inform_to_add_income',
        bodyId: 'informToAddIncomeSourceModal',
    },
    {
        modalType: ssapModalTypes.INFORM_LAWFULLY_PRESENCE_REQUIRED_FOR_COVERAGE_MODAL,
        modalId: 'inform-lawfully-present-required-for-coverage-modal',
        modalHeaderTextData: 'modals.header.citizenship_legal_presence',
        bodyId: 'informLawfullyPresenceRequiredForCoverageModal',
    },
    {
        modalType: ssapModalTypes.INFORM_MEDICARE_ELIGIBLE_MODAL,
        modalId: 'inform-medicare-eligible-modal',
        modalHeaderTextData: 'modals.header.medicare_info',
        bodyId: 'informMedicareEligibleModal',
    },
    {
        modalType: ssapModalTypes.LEAVE_PAGE_MODAL,
        modalId: 'leave-page-modal',
        modalHeaderTextData: 'modals.header.leave_page',
        bodyId: 'leavePageModal',
    },
    {
        modalType: ssapModalTypes.MANDATORY_SEEKING_FOR_COVERAGE_MODAL,
        modalId: 'mandatory-seeking-for-coverage',
        modalHeaderTextData: stateRequiresModalHeader =>
            stateRequiresModalHeader ? 'modals.mandatory_seeking_for_coverage.title' : null,
        bodyId: 'mandatorySeekingForCoverageModal',
    },
    {
        modalType: ssapModalTypes.MULTI_TAX_HOUSEHOLD_MODAL,
        modalId: 'multi-tax-household-modal',
        modalHeaderTextData: 'modals.header.household_info',
        bodyId: 'multiTaxHouseholdModal',
    },
    {
        modalType: ssapModalTypes.OTHER_ADDRESS_MODAL,
        modalId: 'other-address-modal',
        modalHeaderTextData: 'modals.header.other_address',
        formName: 'otherAddressesModalForm',
        bodyId: 'otherAddressModal',
    },
    {
        modalType: ssapModalTypes.REMOVE_MEMBER_MODAL,
        modalId: 'remove-member-modal',
        modalHeaderTextData: 'modals.header.remove_member',
        formName: 'removeMemberModalForm',
        bodyId: 'removeMemberModal',
    },
    {
        modalType: ssapModalTypes.REMOVE_INCOME_OR_DEDUCTION_SOURCE_MODAL,
        modalId: 'remove-income-or-deduction-source-modal',
        modalHeaderTextData: 'modals.header.remove_income_deduction_source',
        bodyId: 'removeIncomeOrDeductionSourceModal',
    },
    {
        modalType: ssapModalTypes.SSAP_EXIT_MODAL,
        modalId: 'ssap-exit-modal',
        modalHeaderTextData: 'modals.header.save_exit_ssap',
        bodyId: 'ssapExitModal',
    },
    {
        modalType: ssapModalTypes.UNDO_MEMBER_REMOVAL_MODAL,
        modalId: 'undo-member-removal-modal',
        modalHeaderTextData: 'modals.header.undo_member_removal',
        bodyId: 'undoMemberRemovalModal',
    },
    {
        modalType: ssapModalTypes.VALIDATE_ADDRESS_MODAL,
        modalId: 'validate-address-modal',
        modalHeaderTextData: 'modals.header.validate_address',
        formName: 'validateAddressModalForm',
        bodyId: 'validateAddressModal',
    },
    {
        modalType: ssapModalTypes.EXTRA_MODAL,
        modalId: 'extra-modal',
        modalHeaderTextData: null,
        formName: 'extraModalForm',
        bodyId: 'extraModal',
    },
];
